document.addEventListener('page:loaded', function(){
    //page loaded

    // if cart quantity is more than 10 then show contact sales popup, code start

    // previous cart quantity
    let previousCart = null;

    // when page loads initially find out cart quantity and call handleMaxCartQuantity
    fetch('/cart.js').then(function(cartResponse){
        return cartResponse.json();
    }).then(function(cart){
        handleMaxCartQuantity(cart, false);
    }).catch(function(error){
        console.error('fetching cart data failed', error);
    });

    // when user changes cart quantity then call handleMaxCartQuantity
    document.addEventListener('cart:updated', (event) => {handleMaxCartQuantity(event.detail.cart, true)});

    const cartDrawer = document.querySelector('#CartDrawer');
    if(cartDrawer){
        const cartDrawerObserver = new MutationObserver(()=>{
            if(cartDrawer.hasAttribute('open')){
                handleMaxCartQuantity(previousCart, false);
            }
        });
        cartDrawerObserver.observe(cartDrawer, {
          attributes: true
        });
    }

    function handleMaxCartQuantity(cart, showPopup = true) {
        const cartQuantity = cart.item_count;
        const checkoutButton = document.querySelector('button[name="checkout"]');
        const isCartQuantityIncreased = previousCart ? (cartQuantity > previousCart.item_count) : true;

        // if cart quantity is more than 10 don't allow checkout instead show contact sales popup
        if(cartQuantity > 10){
            // hide checkout button by adding css class
            checkoutButton.classList.add('incorrect-cart-quantity');

            // add contact sales button
            const checkoutButtonContainer = checkoutButton.closest('form, div');
            let contactSalesButton = checkoutButtonContainer.querySelector('.contact-sales-button');
            if(contactSalesButton === null){
                contactSalesButton = document.createElement('button');
                contactSalesButton.setAttribute('type', 'button');
                contactSalesButton.textContent = 'For bulk orders contact sales';
                contactSalesButton.classList.add('contact-sales-button');
                contactSalesButton.addEventListener('click', showMaxCartQuantityPopup);
                checkoutButtonContainer.insertAdjacentElement("beforeend", contactSalesButton);
            }

            // show contact form popup
            if(showPopup && isCartQuantityIncreased){
                showMaxCartQuantityPopup();
            }
        }
        else{
            // show checkout button
            checkoutButton.classList.remove('incorrect-cart-quantity');
        }
        previousCart = cart;
    }

    function showMaxCartQuantityPopup(){
        const themePopupId = document.querySelector('div:has(> #cart-quantity-exceeds-popup) + button').getAttribute('aria-controls');
        const themePopup = document.querySelector(`#${themePopupId}`);
        themePopup.setAttribute('open', '');
        themePopup.setAttribute('active', '');
    }
    // if cart quantity is more than 10 then show contact sales popup, code end


    // adding css to "cart quantity exceeds contact sales" form, code start
    // to add css inside shadow dom
    const cartQuantityShadowDomSelector = '.drawer__content:has(#cart-quantity-contact-sales-popup) #app-embed';

    afterShadowDomLoaded(cartQuantityShadowDomSelector, function(shadowDomRoot){
        const formContainer = shadowDomRoot.querySelector('#app-embed');
        const styleTag = document.createElement('style');

        styleTag.textContent = `
            section[data-sizing="form-wrapper"]{
                max-width: none !important;
            }

            input[type="text"], input[type="tel"], textarea{
            	font-size: 16px !important;
            }

            @media only screen and (min-width: 768px){
                textarea{
                    height: 100px !important;
                }

                input[type="text"], input[type="tel"]{
                    height: 22px !important;
                }

                button[type="button"]{
                    height: 52px !important;
                    max-height: none;
                }

                form[data-testid="form"] > div label{
                    top: 19px !important;
                }

                form[data-testid="form"]{
                    display: grid !important;
                    gap: 16px !important;
                    grid-template-columns: 1fr 1fr;
                }

                form[data-testid="form"] > div:has(+ output){
                    margin-bottom: 20px;
                }

                form[data-testid="form"] > output{
                    align-self: end;
                }

                form[data-testid="form"] > div:has(#first_name),
                form[data-testid="form"] > div:has(#first_name) + output{
                	grid-column: 1/2;
                	grid-row: 1/2;
                }

                form[data-testid="form"] > div:has(#last_name),
                form[data-testid="form"] > div:has(#last_name) + output{
                	grid-column: 2/3;
                	grid-row: 1/2;
                }

                form[data-testid="form"] > div:has(#email),
                form[data-testid="form"] > div:has(#email) + output{
                	grid-column: 1/2;
                	grid-row: 2/3;
                }

                form[data-testid="form"] > div:has(#phone_number){
                	grid-column: 2/3;
                	grid-row: 2/3;
                }

                form[data-testid="form"] > div:has([name="custom#message"]),
                form[data-testid="form"] > div:has([name="custom#message"]) + output{
                	grid-column: 1/3;
                	grid-row: 3/4;
                }

                button[type="submit"]{
                    justify-self: start !important;
                    padding: 22px 32px !important;
                    font-size: 16px !important;
                    border-radius: 31px !important;
                    grid-column: 1 / 2 !important;
                    grid-row: 4 / 5 !important;
                }
            }

            @media only screen and (max-width: 767px){
                form[data-testid="form"] > div label{
                    top: 14px !important;
                }

                div[data-testid="app-router"]{
                    grid-template-columns: 1fr;
                }
            }
        `;

        formContainer.appendChild(styleTag);
    });
    // adding css to "cart quantity exceeds contact sales" form, code end

    const cartQuantityInputs = document.querySelectorAll('.buy-buttons .quantity__input');
    cartQuantityInputs.forEach(function(cartQuantityInput){
        cartQuantityInput.setAttribute('max', 10);
    });


    // selecting the warrenty form
    // const warrantyFormShadowDomSelector = '.shopify-section:has(#register-warranty-form) + .shopify-section #app-embed';
    const warrantyFormContainer = '.warranty-form-container';

    if(warrantyFormContainer){
        const warrantyFormShadowDomSelector = '.warranty-form-container #app-embed';

        afterShadowDomLoaded(warrantyFormShadowDomSelector, function(shadowDomRoot){
            const formContainer = shadowDomRoot.querySelector('#app-embed');
            const styleTag = document.createElement('style');

            // adding css to "warranty form" inside shadow dom
            styleTag.textContent = `
                section[data-sizing="form-wrapper"]{
                  padding: 40px;
                  margin: 20px;
                  max-width: 550px !important;
                  border-radius: 10px;
                  box-shadow: 0px 2px 20px rgba(235, 236, 239, 1);
                  border: 1px solid #20202033;
                }

                div:has(button[id="custom#upload_receipt-label"] + output) .invoice-input-error{
                	display: none;
                }

                .invoice-input-error{
                    font: var(--forms-body-font);
                    color: var(--form-error-color);
                    line-height: var(--forms-base-font-line-height);
                }

                .invoice-input-error > span{
                    display: inline-block;
                    padding: 10px 0px;
                }

                button[id="custom#upload_receipt-label"].invalid-input-value{
                    border: 2px solid var(--form-error-color);
                }

                @media only screen and (max-width: 767px){
                  section[data-sizing="form-wrapper"] {
                    max-width: none !important;
                    width: 80% !important;
                    padding: 30px;
                  }
                }

                @media only screen and (max-width: 375px){
                  section[data-sizing="form-wrapper"] {
                    padding: 20px;
                  }
                }
            `;

            formContainer.appendChild(styleTag);

            //set maximum file upload size limit on invoice input field in warranty form code start

            // max file size limit 2 MB
            const MAX_FILE_UPLOAD_SIZE = 2 * 1024 * 1024;

            // getting elements 
            const invoiceInputElement = shadowDomRoot.getElementById('custom#upload_receipt-field');
            const invoiceInputButton = shadowDomRoot.getElementById('custom#upload_receipt-label');
            const formSubmitButton = shadowDomRoot.querySelector('button[type="submit"]');

            // disable submit button initially
            //formSubmitButton.setAttribute('disabled', 'disabled');

            // creating error message element
            const invoiceInputError = document.createElement('div');
            invoiceInputError.classList.add('invoice-input-error');
            if(invoiceInputButton){
                invoiceInputButton.closest('div').insertAdjacentElement('beforeend', invoiceInputError);
            }

            if(invoiceInputElement){
                const fileInputObserver = new MutationObserver(function(){
                    const file = invoiceInputElement.files[0];
                    fileInputValidation(file);
                });

                fileInputObserver.observe(invoiceInputButton, {
                    childList: true,
                    subtree: false
                });

                invoiceInputButton.addEventListener('drop', function(event){
                    const file = event.dataTransfer.files[0]
                    fileInputValidation(file);
                })

                function fileInputValidation(file){
                    if(file && file.size > MAX_FILE_UPLOAD_SIZE){
                        // file size is more than 2 Mb
                        showFileInputError('File size should be less than 2 MB');
                    }
                    else if(file && file.size <= MAX_FILE_UPLOAD_SIZE){
                        // file size is ok
                        hideFileInputError();
                    }
                    else{
                        // file not selected
                        showFileInputError('Field is required');
                    }
                }

                function showFileInputError(errorMessage){
                    invoiceInputButton.classList.add('invalid-input-value');
                    invoiceInputError.innerHTML = `<span>${errorMessage}</span>`;
                    formSubmitButton.setAttribute('disabled', 'disabled');
                }

                function hideFileInputError(){
                    invoiceInputButton.classList.remove('invalid-input-value');
                    invoiceInputError.textContent = '';
                    formSubmitButton.removeAttribute('disabled');
                }
            }
            //set maximum file upload size limit on invoice input field in warranty form code end
        });
    }


    // adding tooltip on view more button code start

    const skybitViewMoreButtons = document.querySelectorAll('.shopify-section .quick-view__button');
    skybitViewMoreButtons.forEach(function(viewMoreButton){
        viewMoreButton.insertAdjacentHTML('afterend', '<div class="view-button-tooltip"><div class="view-tooltip-arrow"></div><div class="view-tooltip-text">More details</div></div>');
    });

    // adding tooltip on view more button code end



    // adding css to "notify me when product is back in stock" form inside drawer code start

    const notifyFormShadowDomSelector = '.back-in-stock-notify-drawer #app-embed';

    const notifyFormContainer = document.querySelector('.back-in-stock-notify-drawer');

    if(notifyFormContainer){
        afterShadowDomLoaded(notifyFormShadowDomSelector, function(shadowDomRoot){
            const formContainer = shadowDomRoot.querySelector('#app-embed');
            const styleTag = document.createElement('style');


            styleTag.textContent = `
                [data-sizing="form-wrapper"]{
                    max-width: none !important;
                }

                button[type="submit"]{
                    align-self: start !important;
                    padding: 22px 62px !important;
                    font-size: 16px !important;
                    border-radius: 31px !important;
                }

                form[data-testid="form"] > div label{
                    top: 18px !important;
                }

                div:has(> textarea[name="custom#product"]){
                    visibility: hidden;
                    position: absolute;
                }

                div:has(> textarea[name="custom#product"]) + output{
                    display: none;
                }

                @media only screen and (max-width: 767px){
                    [data-testid="app-router"]{
                        grid-template-columns: 1fr;
                    }
                }
            `;

            formContainer.appendChild(styleTag);
        });
    }

    // adding css to "notify me when product is back in stock" form inside drawer code end



    // show "notify me when product is back in stock" drawer when notify me button is clicked code start

    // to show "notify me when product becomes available in stock" form
    function showNotifyMeForm(productName){
        // getting drawer button
        const drawerButton = document.querySelector('.back-in-stock-form-button');

        // getting drawer id
        const drawerId = drawerButton.getAttribute('aria-controls');

        // getting drawer element
        const drawerElement = document.querySelector(`#${drawerId}`);

        // set product name on drawer title
        drawerElement.querySelector('.drawer__title').textContent = productName;

        // open drawer by adding attributes
        drawerElement.setAttribute('open', '');
        drawerElement.setAttribute('active', '');

        const notifyFormShadowDomSelector = '.back-in-stock-notify-drawer #app-embed';

        afterShadowDomLoaded(notifyFormShadowDomSelector, function(shadowDomRoot){
            const formContainer = shadowDomRoot.querySelector('#app-embed');
            selectProduct(formContainer, productName);
        });
    }

    // open notify form drawer on product pages when notify button is clicked
    const notifyStockButton = document.querySelector('.notify-me-stock-button');
    if(notifyStockButton){
        notifyStockButton.addEventListener('click', function(){
            const productNameElement = document.querySelector('.product__title .heading');
            const productName = productNameElement.textContent.trim();
            showNotifyMeForm(productName);
        });
    }

    // open notify form drawer when notify button inside quick view popup is clicked
    document.addEventListener('quickview:loaded', function() {
        const notifyMeButton = document.querySelector('.notify-me-stock-button');

        if(notifyMeButton){
           notifyMeButton.addEventListener('click', function(){
                const productNameElement = document.querySelector('.product__title .heading');
                const productName = productNameElement.textContent.trim();
                showNotifyMeForm(productName);
           });
        }
    });
    
    // select product in a hidden field
    function selectProduct(formContainer, productName){
        // get the hidden field
        const productNameField = formContainer.querySelector('[name="custom#product"]');

        // add data into the hidden field
        productNameField.focus();
        productNameField.dispatchEvent(new Event('focus', {bubbles: true}));
        
        productNameField.value = productName;

        const inputEvent = new Event('input', {bubbles: true});
        productNameField.dispatchEvent(inputEvent);
        
        productNameField.blur();
        const changeEvent = new Event('change', {bubbles: true});
        productNameField.dispatchEvent(changeEvent);
    }

    // show "notify me when product is back in stock" drawer when notify me button is clicked code end


    // adding css to cta form code start

    const ctaShadowDomSelector = '.skybit-cta-form #app-embed';
    const ctaFormContainer = document.querySelector('.skybit-cta-form');

    if(ctaFormContainer){
        afterShadowDomLoaded(ctaShadowDomSelector, function(shadowDomRoot){
            const formContainer = shadowDomRoot.querySelector('#app-embed');
            const styleTag = document.createElement('style');
        
            styleTag.textContent = `
                section[data-sizing="form-wrapper"]{
                    max-width: none !important;
                }
        
                input[type="text"], input[type="tel"], textarea{
                	font-size: 16px !important;
                }
        
                form[data-testid="form"] > *:empty{
                	display: none;
                }
        
                @media only screen and (min-width: 768px){
                    textarea{
                        height: 100px !important;
                    }
        
                    input[type="text"], input[type="tel"]{
                        height: 22px !important;
                    }
        
                    button[type="button"]{
                        height: 52px !important;
                        max-height: none;
                    }
        
                    form[data-testid="form"] > div label{
                        top: 19px !important;
                    }
        
                    form[data-testid="form"]{
                        display: grid !important;
                        gap: 16px !important;
                        grid-template-columns: 1fr 1fr;
                    }
        
                    form[data-testid="form"] > div:has(+ output){
                        margin-bottom: 20px;
                    }
        
                    form[data-testid="form"] > output{
                        align-self: end;
                    }
        
                    form[data-testid="form"] > div:has(#first_name),
                    form[data-testid="form"] > div:has(#first_name) + output{
                    	grid-column: 1/2;
                    	grid-row: 1/2;
                    }
        
                    form[data-testid="form"] > div:has(#last_name),
                    form[data-testid="form"] > div:has(#last_name) + output{
                    	grid-column: 2/3;
                    	grid-row: 1/2;
                    }
        
                    form[data-testid="form"] > div:has(#email),
                    form[data-testid="form"] > div:has(#email) + output{
                    	grid-column: 1/2;
                    	grid-row: 2/3;
                    }
        
                    form[data-testid="form"] > div:has(#phone_number){
                    	grid-column: 2/3;
                    	grid-row: 2/3;
                    }
        
                    form[data-testid="form"] > div:has([name="custom#message"]),
                    form[data-testid="form"] > div:has([name="custom#message"]) + output{
                    	grid-column: 1/3;
                    	grid-row: 3/4;
                    }
        
                    button[type="submit"]{
                        justify-self: start !important;
                        padding: 22px 32px !important;
                        font-size: 16px !important;
                        border-radius: 31px !important;
                        grid-column: 1 / 2 !important;
                        grid-row: 4 / 5 !important;
                    }
                }
        
                @media only screen and (max-width: 767px){
                    form[data-testid="form"] > div label{
                        top: 14px !important;
                    }
        
                    div[data-testid="app-router"]{
                        grid-template-columns: 1fr;
                    }
                }
            `;
        
            formContainer.appendChild(styleTag);
        });
    }

    // adding css to cta form code end


    // adding css to request a quote form code start

    const rfqShadowDomSelector = '.skybit-rfq-popup #app-embed';

    afterShadowDomLoaded(rfqShadowDomSelector, function(shadowDomRoot){
        const formContainer = shadowDomRoot.querySelector('#app-embed');
        const styleTag = document.createElement('style');

        styleTag.textContent = `
            section[data-sizing="form-wrapper"]{
                max-width: none !important;
            }

            input[type="text"], input[type="tel"], textarea{
            	font-size: 16px !important;
            }

            div:has(> [name="custom#product"]){
            	visibility: hidden;
            	position: absolute;
            }

            form[data-testid="form"] > *:empty{
            	display: none;
            }

            @media only screen and (min-width: 768px){
                textarea{
                    height: 100px !important;
                }

                input[type="text"], input[type="tel"]{
                    height: 22px !important;
                }

                button[type="button"]{
                    height: 52px !important;
                    max-height: none;
                }

                form[data-testid="form"] > div label{
                    top: 19px !important;
                }

                form[data-testid="form"]{
                    display: grid !important;
                    gap: 16px !important;
                    grid-template-columns: 1fr 1fr;
                }

                form[data-testid="form"] > div:has(+ output){
                    margin-bottom: 20px;
                }

                form[data-testid="form"] > output{
                    align-self: end;
                }

                form[data-testid="form"] > div:has(#first_name),
                form[data-testid="form"] > div:has(#first_name) + output{
                	grid-column: 1/2;
                	grid-row: 1/2;
                }

                form[data-testid="form"] > div:has(#last_name),
                form[data-testid="form"] > div:has(#last_name) + output{
                	grid-column: 2/3;
                	grid-row: 1/2;
                }

                form[data-testid="form"] > div:has(#email),
                form[data-testid="form"] > div:has(#email) + output{
                	grid-column: 1/2;
                	grid-row: 2/3;
                }

                form[data-testid="form"] > div:has(#phone_number){
                	grid-column: 2/3;
                	grid-row: 2/3;
                }

                form[data-testid="form"] > div:has([name="custom#message"]),
                form[data-testid="form"] > div:has([name="custom#message"]) + output{
                	grid-column: 1/3;
                	grid-row: 3/4;
                }

                button[type="submit"]{
                    justify-self: start !important;
                    padding: 22px 32px !important;
                    font-size: 16px !important;
                    border-radius: 31px !important;
                    grid-column: 1 / 2 !important;
                    grid-row: 4 / 5 !important;
                }
            }

            @media only screen and (max-width: 767px){
                form[data-testid="form"] > div label{
                    top: 14px !important;
                }

                div[data-testid="app-router"]{
                    grid-template-columns: 1fr;
                }
            }
        `;

        formContainer.appendChild(styleTag);
    });

    // adding css to request a quote form code end

    // adding css to preorder form code starts

    const preorderShadowDomSelector = '.skybit-preorder-popup #app-embed';

    afterShadowDomLoaded(preorderShadowDomSelector, function(shadowDomRoot){
        const formContainer = shadowDomRoot.querySelector('#app-embed');
        const styleTag = document.createElement('style');

        styleTag.textContent = `
            section[data-sizing="form-wrapper"]{
                max-width: none !important;
            }

            input[type="text"], input[type="tel"], textarea{
            	font-size: 16px !important;
            }

            div:has(> [name="custom#product"]){
            	visibility: hidden;
            	position: absolute;
            }

            form[data-testid="form"] > *:empty{
            	display: none;
            }

            @media only screen and (min-width: 768px){
                textarea{
                    height: 100px !important;
                }

                input[type="text"], input[type="tel"]{
                    height: 22px !important;
                }

                button[type="button"]{
                    height: 52px !important;
                    max-height: none;
                }

                form[data-testid="form"] > div label{
                    top: 19px !important;
                }

                form[data-testid="form"]{
                    display: grid !important;
                    gap: 16px !important;
                    grid-template-columns: 1fr 1fr;
                }

                form[data-testid="form"] > div:has(+ output){
                    margin-bottom: 20px;
                }

                form[data-testid="form"] > output{
                    align-self: end;
                }

                form[data-testid="form"] > div:has(#first_name),
                form[data-testid="form"] > div:has(#first_name) + output{
                	grid-column: 1/2;
                	grid-row: 1/2;
                }

                form[data-testid="form"] > div:has(#last_name),
                form[data-testid="form"] > div:has(#last_name) + output{
                	grid-column: 2/3;
                	grid-row: 1/2;
                }

                form[data-testid="form"] > div:has(#email),
                form[data-testid="form"] > div:has(#email) + output{
                	grid-column: 1/2;
                	grid-row: 2/3;
                }

                form[data-testid="form"] > div:has(#phone_number){
                	grid-column: 2/3;
                	grid-row: 2/3;
                }

                form[data-testid="form"] > div:has([name="custom#message"]),
                form[data-testid="form"] > div:has([name="custom#message"]) + output{
                	grid-column: 1/3;
                	grid-row: 3/4;
                }

                button[type="submit"]{
                    justify-self: start !important;
                    padding: 22px 32px !important;
                    font-size: 16px !important;
                    border-radius: 31px !important;
                    grid-column: 1 / 2 !important;
                    grid-row: 4 / 5 !important;
                }
            }

            @media only screen and (max-width: 767px){
                form[data-testid="form"] > div label{
                    top: 14px !important;
                }

                div[data-testid="app-router"]{
                    grid-template-columns: 1fr;
                }
            }
        `;

        formContainer.appendChild(styleTag);
    });

    // adding css to preorder form code ends

    // adding css to contact us form code starts

    const contactFormContainer = document.querySelector('.skybit-contact-form');

    if(contactFormContainer){
        const shadowDomSelector = '.skybit-contact-form #app-embed';
        afterShadowDomLoaded(shadowDomSelector, function(shadowDomRoot){
            const formContainer = shadowDomRoot.querySelector('#app-embed');
            const styleTag = document.createElement('style');
        
            styleTag.textContent = `
                section[data-sizing="form-wrapper"]{
                    max-width: none !important;
                }
        
                input[type="text"], input[type="tel"], textarea{
                	font-size: 16px !important;
                }
        
                form[data-testid="form"] > *:empty{
                	display: none;
                }
        
                @media only screen and (min-width: 768px){
                    textarea{
                        height: 147px !important;
                    }
        
                    input[type="text"], input[type="tel"]{
                        height: 22px !important;
                    }
        
                    button[type="button"]{
                        height: 52px !important;
                        max-height: none;
                    }
        
                    form[data-testid="form"]{
                        display: grid !important;
                        gap: 24px !important;
                        grid-template-columns: 1fr 1fr;
                    }
        
                    form[data-testid="form"] > div:has(+ output){
                        margin-bottom: 20px;
                    }
        
                    form[data-testid="form"] > output{
                        align-self: end;
                    }
        
                    form[data-testid="form"] > div:has(#first_name),
                    form[data-testid="form"] > div:has(#first_name) + output{
                    	grid-column: 1/2;
                    	grid-row: 1/2;
                    }
        
                    form[data-testid="form"] > div:has(#last_name),
                    form[data-testid="form"] > div:has(#last_name) + output{
                    	grid-column: 2/3;
                    	grid-row: 1/2;
                    }
        
                    form[data-testid="form"] > div:has(#email),
                    form[data-testid="form"] > div:has(#email) + output{
                    	grid-column: 1/2;
                    	grid-row: 2/3;
                    }
        
                    form[data-testid="form"] > div:has(#phone_number){
                    	grid-column: 2/3;
                    	grid-row: 2/3;
                    }
        
                    form[data-testid="form"] > div:has([name="custom#message"]),
                    form[data-testid="form"] > div:has([name="custom#message"]) + output{
                    	grid-column: 1/3;
                    	grid-row: 3/4;
                    }
        
                    button[type="submit"]{
                        justify-self: start !important;
                        padding: 22px 32px !important;
                        font-size: 16px !important;
                        border-radius: 31px !important;
	    	            grid-column: 1 / 2 !important;
        		        grid-row: 4 / 5 !important;
                    }
                }
        
                @media only screen and (max-width: 767px){
                    div[data-testid="app-router"]{
                        grid-template-columns: 1fr;
                    }
                }
                
            `;
        
            formContainer.appendChild(styleTag);
        });
    }

    // adding css to contact us form code ends

    // open request a quote popup on button click
    const raqPopup = document.querySelector('.skybit-rfq-popup');
    const raqOpenButtons = document.querySelectorAll('.request-a-quote-modal-open');
    raqOpenButtons.forEach(function(raqOpenButton){
        raqOpenButton.addEventListener('click', function(){
            const productName = raqOpenButton.getAttribute('data-product-name');
            raqPopup.setAttribute('data-product-name', productName);
            raqPopup.show();
        });
    });

    // populating product name into hidden field when raq popup opens
    raqPopup.addEventListener('modal:afterShow', function(){
        const productNameContainer = document.querySelector('.product__title .heading');
        let productName;
        if(productNameContainer){
            productName = productNameContainer.textContent;
        }else{
            productName = raqPopup.getAttribute('data-product-name');
        }

        afterShadowDomLoaded(rfqShadowDomSelector, function(shadowDomRoot){
            const formContainer = shadowDomRoot.querySelector('#app-embed');
            selectProduct(formContainer, productName);
        });
    });

    // open preorder popup on button click
    const preorderPopup = document.querySelector('.skybit-preorder-popup');
    const preorderOpenButtons = document.querySelectorAll('.preorder-form-modal-open');
    preorderOpenButtons.forEach(function(preorderOpenButton){
        preorderOpenButton.addEventListener('click', function(){
            const productName = preorderOpenButton.getAttribute('data-product-name');
            preorderPopup.setAttribute('data-product-name', productName);
            preorderPopup.show();
        });
    });

    // populating product name into hidden field when preorder popup opens
    preorderPopup.addEventListener('modal:afterShow', function(){
        const productNameContainer = document.querySelector('.product__title .heading');
        let productName;
        if(productNameContainer){
            productName = productNameContainer.textContent;
        }else{
            productName = preorderPopup.getAttribute('data-product-name');
        }

        afterShadowDomLoaded(preorderShadowDomSelector, function(shadowDomRoot){
            const formContainer = shadowDomRoot.querySelector('#app-embed');
            selectProduct(formContainer, productName);
        });
    });

});